import axios from "axios";
import { config } from "../config";
import { clientViewState, setAuthorizedClients } from "../utils/clientView";

let loaded = false;
let pendingRequest = null;

/**
 * Carrega as empresas autorizadas uma única vez por sessão da aplicação.
 * Chamadas simultâneas compartilham a mesma Promise para não duplicar o GET.
 */
export function loadBusinessClients() {
  if (loaded) {
    return Promise.resolve([...clientViewState.authorizedClients]);
  }

  if (pendingRequest) {
    return pendingRequest;
  }

  const request = axios
    .get(`${config.API}/v1/download-configurations/business-clients`)
    .then(({ data }) => {
      setAuthorizedClients(data);
      loaded = true;
      return [...clientViewState.authorizedClients];
    })
    .finally(() => {
      if (pendingRequest === request) {
        pendingRequest = null;
      }
    });

  pendingRequest = request;
  return request;
}

export function clearBusinessClientsCache() {
  loaded = false;
  pendingRequest = null;
  setAuthorizedClients([]);
}
